/**
 * ResponsavelAssociadoCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {ResponsavelAssociado} from '@/model/resource/ResponsavelAssociado'

/* TODO: review generated class */
@HttpExclude()
export class ResponsavelAssociadoCollection extends PageCollection<
  ResponsavelAssociado
> {
  constructor() {
    super(ResponsavelAssociado)
  }

  queryAsPage() {
    return this.listResponsavelAssociado()
  }

  async listResponsavelAssociado() {
    return await Request.get(`/admin/responsavel-associado`, {
      params: this.params,
    })
      .name('listResponsavelAssociado')
      .as(this)
      .getResponse()
  }

  async listCsvResponsavelAssociado() {
    return await Request.get(`/admin/responsavel-associado/csv`, {
      params: this.params,
    })
      .name('listCsvResponsavelAssociado')
      .as(this)
      .getResponse()
  }
}
